import { object, string } from 'yup';

import { getFormValidator } from '@util/form/get-form-validator';

export const userProfileFormValidation = getFormValidator(
  object().shape({
    name: string().required('First name is required!'),
    lastname: string().required('Last name is required!'),
    company: string().url(),
  }),
);
